<div class="switch-location-dialog">
  <div class="switch-location-dialog-header flex-between-center">
    <p class="m-0 font-bold">{{ isMultiLocationEnabled ? 'Switch location' : 'Location' }}</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="switch-location-dialog-body flex-column flex-wrap flex-start-start">
    <div *ngFor="let shop of companyLocations" class="mb-2">
      <app-radio-button name="current-location"
        label="{{shop?.name}} {{shop._id === defaultShopId? ' - (Default)' : ''}}" [value]="shop._id"
        [selectedValue]="currentShopId" (appChange)="handleChange(shop._id)"> </app-radio-button>
    </div>
  </div>

  <div class="switch-location-dialog-footer"
    [ngClass]="corporateId || isMarkPsDashboard && !corporateId ? 'flex-between-center' : 'flex-end-center'">
    <button *ngIf="corporateId" class="btn btn-submit switch-view-btn"
      (click)="openCorporateSwitchDialog()"><i class="fas fa-repeat-alt pr-2"></i>
      Switch to another view
    </button>

    <button *ngIf="isMarkPsDashboard && !corporateId" class="btn btn-submit switch-view-btn"
      (click)="redirectToALDashboard()"><i class="fas fa-repeat-alt pr-2"></i>
      Launch Corporate Dashboard
    </button>

    <div [ngClass]="corporateId ? 'flex-end-center': ''">
      <button class="btn btn-white btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
      <button class="btn btn-primary btn-submit" [disabled]="isProcessing" (click)="handleSwitchLocation()">
        Done
        <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
      </button>
    </div>

  </div>
</div>
